import React from 'react';

/**
 * Container de página alinhado ao fluxo da Licença assistida por IA:
 * largura máxima, padding responsivo e fundo neutro.
 */
const FormPageShell = ({ children, className = '', maxWidth = 'max-w-6xl' }) => (
  <div className={`relative mx-auto p-4 sm:p-6 ${maxWidth} ${className}`}>{children}</div>
);

export default FormPageShell;
